import { useState } from "react";
import { MdArrowDownward } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { css } from "../../../styled-system/css";
import { Box, Flex } from "../../../styled-system/jsx";
import { Button } from "../../components/core/basic/Button";
import { HubspotCalendarModal } from "../../components/core/blocks/HubspotCalendarModal";

type TrellisPanelSignUpProps = {
  handleScrollClick: () => void;
};

export function TrellisPanelSignUp({ handleScrollClick }: TrellisPanelSignUpProps) {
  const { t } = useTranslation("auth");
  const [showHubspotModal, setShowHubspotModal] = useState(false);

  return (
    <Flex
      height="100vh"
      alignItems="center"
      justifyContent={{ base: "center", lg: "flex-start" }}
      overflow="hidden"
      pl={{ lg: "10%", xl: "22%" }}
    >
      <Flex
        direction="column"
        justifyContent="center"
        alignItems={{ base: "center", lg: "stretch" }}
        flexWrap="nowrap"
        height="100%"
        px={{ base: "medium", lg: "0" }}
        pr={{ lg: "xlarge" }}
      >
        <Box
          fontSize="xxlarge"
          color="gray.800"
          fontWeight="bold"
          textAlign={{ base: "center", lg: "left" }}
          whiteSpace={{ xl: "nowrap" }}
        >
          {t(($) => $.auth.signup.trellisMarketing["Steps away from your Trellis experience"])}
        </Box>

        <Box
          fontSize="xlarge"
          color="gray.800"
          fontWeight="medium"
          fontStyle="italic"
          mt="large"
          lineHeight="1.7"
          textAlign={{ base: "center", lg: "left" }}
        >
          <ul className={css({ listStyleType: "none", xl: { whiteSpace: "nowrap" } })}>
            <li>{t(($) => $.auth.signup.trellisMarketing["1. Complete your company information."])}</li>
            <li>{t(($) => $.auth.signup.trellisMarketing["2. Sign on with your Amazon account."])}</li>
            <li>{t(($) => $.auth.signup.trellisMarketing["3. Connect your Amazon Advertising Account."])}</li>
            <li>{t(($) => $.auth.signup.trellisMarketing["4. Pick your plan from Billing."])}</li>
          </ul>

          <hr
            className={css({
              width: "50%",
              border: "1px solid",
              borderColor: "gray.300",
              background: "#ddd",
              marginBlock: "large",
              marginInline: "auto",
              lg: { width: "100%", marginTop: "40px" },
            })}
          />
          <p className={css({ textAlign: "center", fontSize: "large", marginTop: "large" })}>
            {t(($) => $.auth.signup["Trusted By"])}
          </p>
          <Flex
            width="100%"
            alignSelf="center"
            className="logo_container"
            flexWrap="nowrap"
            justifyContent={{ base: "center", lg: "space-around" }}
            alignItems="center"
            direction="row"
            mt="medium"
            mb={{ base: "medium", lg: "xlarge" }}
          >
            <div className="logo" />
            <div className="logo" />
            <div className="logo" />
          </Flex>
        </Box>

        <Flex className="fs-standard" direction="column" alignItems="center" fontWeight="bold">
          {t(($) => $.auth.signup.trellisMarketing["Not ready to get started?"])} <br />
          <Button
            variant="link"
            css={{
              fontSize: "large",
              fontWeight: "bold",
            }}
            onPress={() => setShowHubspotModal(true)}
          >
            {t(($) => $.auth.signup.trellisMarketing["Book a Demo"])}
          </Button>
        </Flex>

        <Box display={{ base: "block", lg: "none" }}>
          <Flex justifyContent="center" width="100%">
            <Flex direction="column" minWidth="0" alignItems="center">
              <Box mt="xlarge">{t(($) => $.auth.signup.trellisMarketing.Continue)}</Box>
              <Button
                variant="icon"
                className={css({
                  "& svg": {
                    fontSize: "36px",
                    "& path": {
                      animation: "pulse 1.5s infinite",
                    },
                  },
                })}
                onPress={handleScrollClick}
              >
                <MdArrowDownward />
              </Button>
            </Flex>
          </Flex>
        </Box>
      </Flex>

      <HubspotCalendarModal isOpen={showHubspotModal} onOpenChange={setShowHubspotModal} />
    </Flex>
  );
}
